<template>
  <div class="conteudo-container">
    <g-menu-sidebar
    class="conteudo-resumo-topo"
    titulofechado="Orçamento - Produto Repetição c/ Alteração"
    tituloaberto="Resumo"
    >
      <template #conteudo>
        <div class="conteudo-card-resumo-topo">
          <div class="grupo parametros">
            <div class="titulo-icone-parametros">
              <i class="pi pi-check"></i>
              <div class="titulo-topico"> Parâmetros </div>
            </div>

            <div class="topico topico-parametros">
              <div class="parametros-orcamento">
                <div class="titulo"> Orçamento </div>
                <div class="conteudo">{{resumoobj.codigoOrcamento}}</div>
              </div>
              
              <div class="parametros-tipo">
                <div class="titulo"> Tipo </div>
                <div class="conteudo">{{resumoobj.tipoFluxoOrcamentoEnumTexto}}</div>
              </div>
              
              <div class="parametros-representante">
                <div class="titulo"> Representante </div>
                <div class="conteudo">{{resumoobj.nomeRepresentante}}</div>
              </div>
              
              <div class="parametros-unidade">
                <div class="titulo"> Unidade </div>
                <div class="conteudo">{{resumoobj.nomeEmpresa}}</div>
              </div>
            </div>
          </div>

          <div v-if="steps >= 1" class="grupo cliente">
            <div class="titulo-icone">
              <i class="pi pi-user"></i>
              <div class="titulo-topico"> Cliente </div>
            </div>

            <div class="topico-cliente">
              <div class="cliente-razao-social">
                <div class="titulo"> Razão Social </div>
                <div class="conteudo conteudo-cliente-razao-social">{{resumoobj.razaoSocial}}</div>
              </div>

              <div class="cliente-cnpj">
                <div class="titulo"> CNPJ </div>
                <div class="conteudo">{{MascaraCnpj}}</div>
              </div>
            </div>
          </div>

          <div v-if="steps >= 2" class="grupo entrega">
            <div class="titulo-icone">
              <i class="pi pi-sync"></i>
              <div class="titulo-topico"> Entrega </div>
            </div>

            <div class="topico-entrega">
              <div class="entrega-frete">
                <div class="titulo"> Frete </div>
                <div class="conteudo">{{resumoobj.indicadorDeTipoFreteTexto}}</div>
              </div>
              
              <div class="entrega-codigo-cidade">
                <div class="titulo"> Código Cidade </div>
                <div class="conteudo">{{resumoobj.codigoCidade}}</div>
              </div>
              
              <div class="entrega-tipo-frete">
                <div class="titulo"> Tipo do Frete </div>
                <div class="conteudo"> {{ resumoobj.cidadeTipoFreteEnumTexto }} </div>
              </div>

              <div class="entrega-tipo-frete">
                <div class="titulo">Tipo de Lote </div>
                <div class="conteudo"> {{ resumoobj.informacaoLoteEnumTexto }} </div>
              </div>

              <div class="entrega-tipo-frete">
                <div class="titulo">Sequência </div>
                <div class="conteudo"> {{resumoobj.sequenciaTexto }} </div>
              </div>
            </div>
          </div>

          <div v-if="steps >= 3" class="grupo produto">
            <div class="titulo-icone">
              <i class="pi pi-box"></i>
              <div class="titulo-topico"> Produto </div>
            </div>

            <div class="topico topico-produto">
              <div class="produto-nome">
                <div class="titulo"> Nome </div>
                <div class="conteudo conteudo-produto-nome">{{resumoobj.nomeProduto}}</div>
              </div>
              
              <div class="quantidade-dia-carregamento">            
                <div class="produto-quantidade">
                  <div class="titulo"> Quantidade </div>
                  <div class="conteudo" v-for="data in resumoObj"
                  :key="data.id">{{data.quantidade}}</div>
                </div>

                <div class="produto-data-carregamento">
                  <div class="titulo"> Data de Carregamento </div>
                  <div class="conteudo" v-for="data in resumoObj"
                  :key="data.id">{{data.dataQuantidadeCarregamento}}</div>
                </div>
              </div>

              <div class="componentes-medidas">
                <div v-if="steps >= 4" class="produto-componentes">
                  <div class="titulo"> Componentes </div>              
                  <div class="conteudo" v-for="data in resumoObjComp"
                  :key="data.id">{{data.componenteTipoText}}</div>

                  <div class="conteudo" v-if="!nomeComponente"> Não possui componentes. </div>
                </div>
              
                <div v-if="steps >= 4" class="produto-medidas">
                  <div class="titulo"> Medidas </div>
                  <div class="conteudo" v-for="data in resumoObjComp"
                  :key="data.id">{{data.numeroComprimento}} X {{data.numeroLargura}} X {{data.numeroAltura}}</div>                  

                  <div class="conteudo" v-if="!nomeComponente"> 0 X 0 X 0 </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </g-menu-sidebar> 
    
    <g-card :temCabecalho="false">
      <g-steps :metadeLargura="false" @RouterIndex="verificarTabs" :items="items"></g-steps>         
    </g-card>

    <g-card-resumo 
      class="conteudo-resumo-lateral"
      titulofechado="RESUMO DO ORÇAMENTO" 
      tituloaberto="RESUMO DO ORÇAMENTO"
      :larguraCResumoLateral="true"
    >      
      <div class="conteudo-card-resumo">
        <div class="grupo parametros">
          <div class="titulo-icone-parametros">
            <i class="pi pi-check"></i>
            <div class="titulo-topico"> Parâmetros </div>
          </div>

          <div class="topico topico-parametros">
            <div class="parametros-orcamento">
              <div class="titulo"> Orçamento </div>
              <div class="conteudo">{{resumoobj.codigoOrcamento}}</div>
            </div>
            
            <div class="parametros-tipo">
              <div class="titulo"> Tipo </div>
              <div class="conteudo">{{resumoobj.tipoFluxoOrcamentoEnumTexto}}</div>
            </div>
            
            <div class="parametros-representante">
              <div class="titulo"> Representante </div>
              <div class="conteudo">{{resumoobj.nomeRepresentante}}</div>
            </div>
            
            <div class="parametros-unidade">
              <div class="titulo"> Unidade </div>
              <div class="conteudo">{{resumoobj.nomeEmpresa}}</div>
            </div>
          </div>
        </div>

        <div v-if="steps >= 1" class="grupo cliente">
          <div class="titulo-icone">
            <i class="pi pi-user"></i>
            <div class="titulo-topico"> Cliente </div>
          </div>

          <div class="topico-cliente">
            <div class="cliente-razao-social">
              <div class="titulo"> Razão Social </div>
              <div class="conteudo conteudo-cliente-razao-social">{{resumoobj.razaoSocial}}</div>
            </div>

            <div class="cliente-cnpj">
              <div class="titulo"> CNPJ </div>
              <div class="conteudo">{{MascaraCnpj}}</div>
            </div>
          </div>
        </div>

        <div v-if="steps >= 2" class="grupo entrega">
          <div class="titulo-icone">
            <i class="pi pi-sync"></i>
            <div class="titulo-topico"> Entrega </div>
          </div>

          <div class="topico-entrega">
            <div class="entrega-frete">
              <div class="titulo"> Frete </div>
              <div class="conteudo">{{resumoobj.indicadorDeTipoFreteTexto}}</div>
            </div>
            
            <div class="entrega-codigo-cidade">
              <div class="titulo"> Código Cidade </div>
              <div class="conteudo">{{resumoobj.codigoCidade}}</div>
            </div>
            
            <div class="entrega-tipo-frete">
              <div class="titulo"> Tipo do Frete </div>
              <div class="conteudo"> {{ resumoobj.cidadeTipoFreteEnumTexto }} </div>
            </div>
            <div class="entrega-tipo-frete">
              <div class="titulo">Tipo de Lote </div>
              <div class="conteudo"> {{ resumoobj.informacaoLoteEnumTexto }} </div>
            </div>
            <div class="entrega-tipo-frete">
              <div class="titulo">Sequência </div>
              <div class="conteudo"> {{resumoobj.sequenciaTexto }} </div>
            </div>
          </div>
        </div>

        <div v-if="steps >= 3" class="grupo produto">
          <div class="titulo-icone">
            <i class="pi pi-box"></i>
            <div class="titulo-topico"> Produto </div>
          </div>

          <div class="topico topico-produto">
            <div class="produto-nome">
              <div class="titulo"> Nome </div>
              <div class="conteudo conteudo-produto-nome">{{resumoobj.nomeProduto}}</div>
            </div>
            
            <div class="quantidade-dia-carregamento">            
              <div class="produto-quantidade">
                <div class="titulo"> Quantidade </div>
                <div class="conteudo" v-for="data in resumoObj"
                :key="data.id">{{data.quantidade}}</div>
              </div>

              <div class="produto-data-carregamento">
                <div class="titulo"> Data de Carregamento </div>
                <div class="conteudo" v-for="data in resumoObj"
                :key="data.id">{{data.dataQuantidadeCarregamento}}</div>
              </div>
            </div>

            <div class="componentes-medidas">
              <div v-if="steps >= 4" class="produto-componentes">
                <div class="titulo"> Componentes </div>              
                <div class="conteudo" v-for="data in resumoObjComp"
                :key="data.id">{{data.componenteTipoText}}</div>

                <div class="conteudo" v-if="!nomeComponente"> Não possui componentes. </div>
              </div>
              
              <div v-if="steps >= 4" class="produto-medidas">
                <div class="titulo"> Medidas </div>
                <div class="conteudo" v-for="data in resumoObjComp"
                :key="data.id">{{data.numeroComprimento}} X {{data.numeroLargura}} X {{data.numeroAltura}}</div>                  

                <div class="conteudo" v-if="!nomeComponente"> 0 X 0 X 0 </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </g-card-resumo> 
  </div>
</template>

<script>
import ProdutoRepeticaoAlteracaoRA from "./ProdutoRepeticaoAlteracao.js";
export default ProdutoRepeticaoAlteracaoRA;
</script>

<style scoped>
.conteudo-card-resumo-topo {
  padding: 0 10px;
}

.titulo-icone, .titulo-icone-parametros {
  color: #4f2c19;
  text-align: left;
  font-family: "MontSerrat";
  font-weight: bold;
  display: flex;
  align-items: center;
  font-size: 18px;
}

.titulo-icone-parametros {
  margin-top: 15px;
}

.titulo-icone {
  border-top: 1px solid #e9e9e9;
  margin-top: 20px;
  padding-top: 20px;
}

.titulo-topico {
  padding-left: 8px;
}

.topico, .quantidade-dia-carregamento, .componentes-medidas, .topico-cliente {
  display: grid;
  grid-column-gap: 20px;
  grid-row-gap: 10px;
}

.topico, .quantidade-dia-carregamento, .componentes-medidas {
  grid-template-columns: 35% 60%;
}

.topico-parametros {
  margin: 10px 0 20px 0;
}

.topico-cliente {
  grid-template-columns: 55% 40.5%;
  margin: 10px 0 20px 0;
}

.topico-entrega {
  display: flex;
  flex-wrap: wrap;
  column-gap: 30px;
  row-gap: 10px;
  margin: 10px 0 20px 0;
}

.topico-produto {
  display: flex;
  flex-direction: column;
  margin: 10px 0 20px 0;
}

.titulo {
  color: #3e3e3e;
  text-align: left;
  font-family: "MontSerrat";
  font-weight: 500;
}

.conteudo {
  color: #8a8a8a;
  text-align: left;
  font-family: "MontSerrat";
  /* As linhas abaixo servem para colocar reticencias nas legendas se passarem do tamanho delimitado*/
  /* text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden; */
}

@media (min-width:310px) {
.conteudo-resumo-topo {
  display: block;
}

.conteudo-resumo-lateral {
  display: none;
}
}

@media (min-width:368px) {

}

@media (min-width:600px) {

}

@media (min-width:801px) {

}

@media (min-width:1025px) { 
.conteudo-container {
  display: flex;
  justify-content: space-between;
}

.conteudo-resumo-topo {
  display: none;
}

.conteudo-resumo-lateral {
  display: block;
}
}

@media (min-width:1281px) { 
    
} 
</style>




